module.exports = __webpack_public_path__ + "img/georgievsk_places.93178066.jpeg";